// extracted by mini-css-extract-plugin
module.exports = {"cardWrap":"mock-form_cardWrap_5a22J","btnWrap":"mock-form_btnWrap_2DHCy","validate":"mock-form_validate_3xKG5"};